import { render, staticRenderFns } from "./TimeToAnswerConfig.vue?vue&type=template&id=47980c1f&scoped=true&"
import script from "./TimeToAnswerConfig.vue?vue&type=script&lang=js&"
export * from "./TimeToAnswerConfig.vue?vue&type=script&lang=js&"
import style0 from "./TimeToAnswerConfig.vue?vue&type=style&index=0&id=47980c1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47980c1f",
  null
  
)

export default component.exports